import * as React from 'react';
const SvgDropDown = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} viewBox="0 0 24 24">
        <path fill="currentColor" d="m7 10 5 5 5-5z" />
    </svg>
);
export default SvgDropDown;
